import React, { useEffect, useState, useContext } from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import useUserData from "../../../../../../hooks/user/useUserData";
import { ConfigContext } from '../../../../../../theme/mantis/contexts/configContext';
import { useHasPermission } from "../../../../../../modules/permission/hooks/useHasPermission";
const CircularCountdown = ({ duration = 540, onComplete }) => {
	const [timeLeft, setTimeLeft] = useState(duration);
	const { isLoggedIn } = useUserData();
	const theme = useTheme();
	const matchDownSM = useMediaQuery(theme.breakpoints.down('sm'));
    const { resetCountdownKey, onResetCountdown } = useContext(ConfigContext);
	const isAdmin = useHasPermission(['access_mobile_side_menu'], { shouldView: true })

	// Reset timeLeft whenever resetCountdownKey changes
	useEffect(() => {
		setTimeLeft(duration);
	}, [resetCountdownKey]);

	useEffect(() => {
		let timer;
		if (matchDownSM || isAdmin) {
			// Stop and reset if in mobile
			setTimeLeft(duration);
			return;
		}

		if (timeLeft <= 0) {
			if (!isLoggedIn) return;
			onComplete?.();
			return;
		}

		timer = setInterval(() => {
			setTimeLeft((prev) => prev - 1);
		}, 1000);

		return () => clearInterval(timer);
	}, [timeLeft, matchDownSM]);

	const percentage = (timeLeft / duration) * 100;

	const formatTime = (seconds) => {
		const min = Math.floor(seconds / 60);
		const sec = seconds % 60;
		return `${min}:${sec < 10 ? '0' : ''}${sec}`;
	};

	if (matchDownSM || isAdmin) return null;

	return (
		<Box
			className="circular-countdown"
			position="relative"
			display="inline-flex"
			alignItems="center"
			justifyContent="center"
			onClick={()=>{onResetCountdown()}}
			sx={{cursor:'pointer'}}
		>
			{/* Background circle */}
			<CircularProgress
				variant="determinate"
				value={100}
				size={35}
				thickness={5}
				sx={{
					color: '#E6EAF5',
					position: 'absolute',
				}}
			/>
			{/* Foreground (countdown) circle */}
			<CircularProgress
				variant="determinate"
				value={percentage}
				size={35}
				thickness={5}
				sx={{ color: '#485476' }}
			/>
			{/* Center text */}
			<Box
				position="absolute"
				top={0}
				left={0}
				right={0}
				bottom={0}
				display="flex"
				alignItems="center"
				justifyContent="center"
			>
				<Typography variant="h6" fontWeight="bold" color="#485476" sx={{ fontSize: '8px' }}>
					{formatTime(timeLeft)}
				</Typography>
			</Box>
		</Box>
	);
};

export default CircularCountdown;
